import { render, staticRenderFns } from "./addPrice.vue?vue&type=template&id=6643b69e&"
import script from "./addPrice.vue?vue&type=script&lang=js&"
export * from "./addPrice.vue?vue&type=script&lang=js&"
import style0 from "./addPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports